import React from 'react';
import { Dialog, Grid, Radio, RadioGroup } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import uldStyles from './uld.module.css';
import { CustomButton, CustomDialogAction, CustomDialogContent, CustomDialogTitle, CustomInputLabel, CustomRadio, CustomTextField, InputProps, StyledCard } from '../../../../../custom/components';
import { CloseIconBtn } from 'custom/constants';

const UldModal = (props) => {
  const { action, uldFields, uldErrors, onChange, addMail, editMail } = props;
  // const ac_typs = [
  //   '777', '744', '35M', '76K', '76Z', '76L',
  //   '35L', '359', '339', '332', '764', '76D',
  //   '3M2', '333', '3M3', '33G', '33X', '3MX'
  // ];
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.uldModal} onClose={props.onClose} maxWidth={'sm'} fullWidth>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
          {action == 'add' ? 'Add' : 'Edit'} ULD
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <form onSubmit={action == 'add' ? addMail : editMail} onReset={props.onClose} className={styles.w100}>
          <CustomDialogContent>
            <StyledCard>
              <Grid container spacing={2} className={styles.formGrid}>
                <Grid item xs={12} sm={12}>
                  <CustomInputLabel htmlFor='prefix' required>Prefix</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    autoFocus
                    id='prefix'
                    placeholder='Prefix'
                    type='text'
                    onChange={onChange}
                    name='prefix'
                    value={uldFields.prefix}
                    error={Boolean(uldErrors.prefix)}
                    helperText={uldErrors.prefix}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={12}>
                  <CustomInputLabel htmlFor='wgt' required>Weight</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    id='wgt'
                    placeholder='Weight'
                    type='number'
                    onChange={onChange}
                    name='wgt'
                    value={uldFields.wgt}
                    error={Boolean(uldErrors.wgt)}
                    helperText={uldErrors.wgt}
                  />
                </Grid> */}
                
                <Grid item xs={12}>
                  <CustomInputLabel htmlFor='type' required className={`${styles.pb2}`}>Type</CustomInputLabel>
                  <RadioGroup
                    aria-label='type'
                    name='type'
                    value={uldFields.type || ''}
                    onChange={onChange}
                    row
                    sx={{
                      marginRight: '-12px',
                      marginLeft: '12px',
                    }}
                  >
                    <Grid container spacing={1}>
                      <Grid item xs={6} md={2.4}>
                        <CustomRadio
                          key={'LD3'}
                          value={'LD3'}
                          control={<Radio />}
                          label={'LD3'}
                          className={uldStyles.checkboxRoot}
                        />
                      </Grid>
                      <Grid item xs={6} md={2.4}>
                        <CustomRadio
                          key={'2X LD3'}
                          value={'2X LD3'}
                          control={<Radio />}
                          label={'2X LD3'}
                          className={uldStyles.checkboxRoot}
                        />
                      </Grid>
                      <Grid item xs={6} md={2.4}>
                        <CustomRadio
                          key={'LD7'}
                          value={'LD7'}
                          control={<Radio />}
                          label={'LD7'}
                          className={uldStyles.checkboxRoot}
                        />
                      </Grid>
                      {/* <Grid item xs={6} md={2.4}>
                        <CustomRadio
                          key={'MD'}
                          value={'MD'}
                          control={<Radio />}
                          label={'MD'}
                          className={uldStyles.checkboxRoot}
                        />
                      </Grid>
                      <Grid item xs={6} md={2.4}>
                        <CustomRadio
                          key={'2X MD'}
                          value={'2X MD'}
                          control={<Radio />}
                          label={'2X MD'}
                          className={uldStyles.checkboxRoot}
                        />
                      </Grid> */}
                    </Grid>
                  </RadioGroup>
                </Grid>
                {/* <Grid item xs={12}>
                  <CustomInputLabel htmlFor='ac' required className={`${styles.pb2}`}>AC Types</CustomInputLabel>
                  <FormControl component='fieldset' variant='standard'>
                    <FormGroup row                     
                      sx={{
                        marginRight: '-12px',
                        marginLeft: '12px',
                      }}
                    >
                      <Grid container spacing={1}>
                        {ac_typs.map((type) => (
                          <Grid key={type} item xs={6} md={2} lg={2}>
                            <CustomCheckbox
                              control={
                                <Checkbox
                                  checked={uldFields?.ac_type?.includes(type)}
                                  onChange={onChange}
                                  name={type}
                                />
                              }
                              label={type}
                              className={uldStyles.checkboxRoot}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </FormGroup>
                  </FormControl>
                </Grid> */}
              </Grid>
            </StyledCard>
          </CustomDialogContent>
          <CustomDialogAction className={`${styles.fSpaceBtw}`}>
            <CustomButton variant='contained' type='reset'> Close</CustomButton>
            <CustomButton variant='contained' type='submit'>{action == 'add' ? 'Submit' : 'Update'}</CustomButton>
          </CustomDialogAction>
        </form>
      </Dialog>
    </div>
  );
};
export default UldModal;